export interface ExportedAsset {
    id: number;
    export: number;
    variant: number;
    version: number;
    file: string;
    format: string;
    name: string;
    width: number;
    height: number;
}

export interface Export {
    id?: number;
    creative: number;
    formats: string[];
    exportedBy?: number;
    exportedAssets?: ExportedAsset[];
    createdAt?: string;
}
